// frontend/src/services/inkeyApi.js
// Inkey PMS Integration API Service

import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || '/api';

const apiClient = axios.create({
  baseURL: `${API_URL}/inkey`,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  withCredentials: true,
  timeout: 30000,
});

// Add Authorization token to all requests
apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const inkeyApi = {
  /** Get configured Inkey devices. */
  getConfig: async () => {
    try {
      const response = await apiClient.get('/devices');
      return response.data;
    } catch (error) {
      console.error('Error fetching Inkey config:', error);
      throw error;
    }
  },

  /** Create an Inkey device configuration. */
  updateConfig: async (config) => {
    try {
      const response = await apiClient.post('/devices', config);
      return response.data;
    } catch (error) {
      console.error('Error updating Inkey config:', error);
      throw error;
    }
  },

  updateDevice: async (deviceId, config) => {
    const response = await apiClient.put(`/devices/${deviceId}`, config);
    return response.data;
  },

  deleteDevice: async (deviceId) => {
    const response = await apiClient.delete(`/devices/${deviceId}`);
    return response.data;
  },

  syncDevice: async (deviceId) => {
    const response = await apiClient.post(`/devices/${deviceId}/sync`);
    return response.data;
  },

  testConnection: async (credentials) => {
    const response = await apiClient.post('/test-connection', credentials);
    return response.data;
  },

  /**
   * Get Inkey service status
   */
  getStatus: async () => {
    try {
      const response = await apiClient.get('/status');
      return response.data;
    } catch (error) {
      console.error('Error fetching Inkey status:', error);
      throw error;
    }
  },

  /**
   * Get Inkey metrics
   */
  getMetrics: async () => {
    try {
      const response = await apiClient.get('/metrics');
      return response.data;
    } catch (error) {
      console.error('Error fetching Inkey metrics:', error);
      throw error;
    }
  },

  /**
   * Manually trigger Inkey sync
   */
  triggerSync: async () => {
    try {
      const response = await apiClient.post('/sync');
      return response.data;
    } catch (error) {
      console.error('Error triggering Inkey sync:', error);
      throw error;
    }
  },

};
